import {
	SR_PURCHASE_ORDER_LIST,
	SR_PURCHASE_ORDER_LIST_SUCCESS,
	SR_SERVICE_INDENT_LIST,
	SR_SERVICE_INDENT_LIST_SUCCESS,
	SR_TOGGLE_ITEM_MENU,
	SR_SET_PARAMS,
	FILTER_INPUT_SR_CHANGEVALUE,
	FILTER_SELECT_SR_CHANGEVALUE,
	SR_PURCHASE_ORDER_ROW_DATA,
	SR_PURCHASE_ORDER_ROW_DATA_SUCCESS,
	SR_LIST_LAYOUT,
	FILTERS_SHOW_SRQ_RIGHT_SIDEBAR,
	FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	SR_PDF_DOWNNLOAD,
	MR_SR_CODE_DETAILS,
	MR_SR_CODE_DETAILS_SUCCESS,
	PI_SR_CODE_DETAILS,
	PI_SR_CODE_DETAILS_SUCCESS,
	SR_PO_ITEM_ACKNOWLEDGE_OPEN,
	SR_PO_ITEM_ACKNOWLEDGE_CLOSE,
	SR_PO_ITEM_INPUT_SR_CHANGEVALUE,
	SR_PO_ITEM_ACKNOWLEDGE,
	SR_PURCHASE_ORDER_CLOSE,
	SR_PURCHASE_ORDER_FOUCS_POST,
	PO_CLOSE_SR_MODAL_OPEN,
	PO_CLOSE_SR_MODAL_CLOSE,
	PO_CLOSE_SR_DESCRIPTION,
	SR_TOGGLE_EDIT,
	ORDER_DISC_PERCENT_SR_CHANGEVALUE,
	HANDLE_SR_BASE_PRICE,
	ITEM_GROSS_VAL_SR_CHANGEVALUE,
	ORDER_BASEPRICE_SR_CHANGEVALUE,
	ORDER_TAXTYPE_SR_CHANGEVALUE,
	ORDER_TAX_SR_CHANGEVALUE,
	SUBMIT_SR_EDIT_ORDER,
	SUBMIT_SR_EDIT_ORDER_SUCCESSFULL,
	VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE,
	SR_TOGGLE_EDIT_WITH_VALUE,
	PO_SR_HISTORY_SUCCESS,
	INPUT_SERVICE_REQUEST_CHANGEVALUE,
	SERVICE_REQUEST_NO_SELECT_SR_CHANGEVALUE,
	SERVICE_REQUEST_Location_SELECT_SR_CHANGEVALUE,
	SELECT_SERVICE_REQUEST_CHANGEVALUE,
	SR_SERVICE_REQUEST_ROW_DATA,
	SR_SERVICE_REQUEST_ROW_DATA_SUCCESS,
	RFQ_MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SR_MODEL_CLOSE,
	SR_SERVICE_REQUEST_Q_VENDORS_LIST,
	SR_SERVICE_REQUEST_Q_VENDORS_LIST_SUCCESS,
	SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_DISC_PERCENT_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_PRICE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_TAXTYPE_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_GROSS_VAL_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_ITEM_TAX_SR_CHANGEVALUE,
	SR_SERVICE_REQUEST_QUOTATION_ADD,
	WO_AUTHORIZATION,
	WO_AUTHORIZATION_SUCCESS,
	APPROVE_WO_EDIT_WITH_VALUE,
	SET_MR_ERROR_MESSAGE,
} from "./actionTypes";

const initialState = {
	loading: false,
	POList: [],
	toggledRows: {},
	serviceIndent: [],
	POListCount: 0,
	PORowData: {},
	ServiceRequestrowdata: [],
	POItemHistory: [],
	Sortvar: {
		code: "ORDER NO",
		createdon: "CREATED ON",
	},
	QRowData: {},
	QRfQNo: {},
	location: {},
	qitems: [],
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
	layout: "list",
	POIacknowledgeData: {},
	POIacknowledge_Model: false,
	showFilterRightSidebar: false,
	POClose_Model: false,
	POClose_Model_Description: {},
	ToggleEditBtn: false,
	showViewLogRightSidebar: false,
	itemTimeLine: [],
	mrIssueItem: [],
	PIitemTimeLine: [],
	RFQItemsTimeLine: [],
	POItemsTimeLine: [],
	IGPItemsTimeLine: [],
	IGPTimeLine: [],
	selectedPIItemId: 0,
	selectedCQItemId: 0,
	selectedIGPItemId: 0,
	RFQMRItemImagesModel: false,
	WoAuthorization: {},
};

const SRPurchaseOrder = (state = initialState, action) => {
	switch (action.type) {
		case SR_PURCHASE_ORDER_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_PURCHASE_ORDER_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				POListCount: action.payload.count,
				POList: action.payload.results,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case SR_SERVICE_INDENT_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_SERVICE_INDENT_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				POListCount: action.payload.count,
				serviceIndent: action.payload.results,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			// state = {
			// 	...state,
			// 	serviceIndent: action.payload,
			// 	loading: false,
			// };
			break;

		case WO_AUTHORIZATION:
			state = {
				...state,
				WoAuthorization: action.payload,
				loading: true,
			};
			break;
		case WO_AUTHORIZATION_SUCCESS:
			state = {
				...state,
				WoAuthorization: action.payload,
				loading: false,
			};
			break;
		case APPROVE_WO_EDIT_WITH_VALUE:
			state = {
				...state,
				toggledRows: action.payload,
			};
			break;
		case SR_SERVICE_REQUEST_Q_VENDORS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_SERVICE_REQUEST_Q_VENDORS_LIST_SUCCESS:
			state = {
				...state,
				QVendorsList: action.payload,
				loading: false,
			};
			break;

		case SR_SERVICE_REQUEST_QUOTATION_ADD:
			state = {
				...state,
				loading: true,
			};
			break;
		case INPUT_SERVICE_REQUEST_CHANGEVALUE:
			state = {
				...state,
				QRowData: {
					...state.QRowData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case SERVICE_REQUEST_NO_SELECT_SR_CHANGEVALUE:
			state = {
				...state,
				QRfQNo: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SERVICE_REQUEST_Location_SELECT_SR_CHANGEVALUE:
			state = {
				...state,
				location: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SELECT_SERVICE_REQUEST_CHANGEVALUE:
			state = {
				...state,
				QRowData: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SR_SERVICE_REQUEST_ROW_DATA:
			state = {
				...state,
				loading: true,
				QRowData: {},
				qitems: [],
			};
			break;
		case SR_SERVICE_REQUEST_ROW_DATA_SUCCESS:
			console.log("ACtio.........", action.payload);
			var qItems = [];
			action.payload.siitems.map((i) => {
				var qitem = {
					id: i.id,
					rfqitem: i.id,
					product: i.product,
					originalqty: i.qty,
					qty: i.qty,
					unit: i.unit,
					unit_id: i.unit.id,
					make: i.make,
					description: i.description,
					discount: 0,
					discountpercent: 0,
					// qitems.taxtype = 1;
					// qitems.tax = i.tax;
				};
				qItems.push(qitem);
				return i;
			});
			state = {
				...state,
				ServiceRequestrowdata: action.payload,
				qitems: qItems || [],
				loading: false,
			};
			break;
		case SR_SERVICE_REQUEST_ITEM_DISC_PERCENT_SR_CHANGEVALUE:
			var qitems7 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.discountpercent = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7 || [],
			};
			break;

		case SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE:
			var qitems8 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.baseprice = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
					// i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems8 || [],
			};
			break;

		case SR_SERVICE_REQUEST_ITEM_PRICE_SR_CHANGEVALUE:
			var qitems3 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.price = action.payload.value;
					i.discount = action.payload.discount;
					i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems3 || [],
			};
			break;

			break;
		case SR_SERVICE_REQUEST_ITEM_TAXTYPE_SR_CHANGEVALUE:
			var qitems4 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.taxtype = {
						id: action.payload.value,
						name: action.payload.label,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems4 || [],
			};
			break;

		case SR_SERVICE_REQUEST_ITEM_GROSS_VAL_SR_CHANGEVALUE:
			var qitems6 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.gross = parseFloat(action.payload.net);
					i.taxamt = parseFloat(action.payload.taxamt);
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems6 || [],
			};
			break;

		case SR_SERVICE_REQUEST_ITEM_TAX_SR_CHANGEVALUE:
			var qitems5 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.tax = {
						id: action.payload.id,
						tax: action.payload.tax,
						name: action.payload.name,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems5 || [],
			};
			break;

		case RFQ_MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SR_MODEL_CLOSE:
			state = {
				...state,
				RFQMRItemImagesModel: false,
			};
			break;
		case SR_TOGGLE_ITEM_MENU:
			var POList = state.POList?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				POList: POList,
			};
			break;
		case SR_SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_SR_CHANGEVALUE:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_SR_CHANGEVALUE:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE:
			var qitems3 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.price = action.payload.value;
					i.discount = action.payload.discount;
					i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems3 || [],
			};
			break;
		case SR_TOGGLE_EDIT:
			state = {
				...state,
				// ToggleEditBtn: !state.ToggleEditBtn,
				PORowData: {
					...state.PORowData,
					poitems: state.PORowData?.poitems?.map((item) => {
						if (item.showEditBtn != undefined) {
							if (item.id == action.payload) {
								item.showEditBtn = !item.showEditBtn;
							}
						} else {
							item.showEditBtn = false;
						}
						return item;
					}),
				},
			};
			break;
		case SR_TOGGLE_EDIT_WITH_VALUE:
			state = {
				...state,
				ToggleEditBtn: action.payload,
			};
			break;
		case SR_PURCHASE_ORDER_ROW_DATA:
			state = {
				...state,
				loading: true,
				PORowData: {},
			};
			break;
		case SR_PURCHASE_ORDER_ROW_DATA_SUCCESS:
			state = {
				...state,
				PORowData: {
					...action.payload,
					woitems: action.payload?.woitems?.map((item) => {
						item.showEditBtn = false;
						return item;
					}),
				},
				loading: false,
			};
			break;
		case MR_SR_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				poItemId: action.payload.ItemId,
			};
			break;
		case SET_MR_ERROR_MESSAGE:
			return {
				...state,
				loading: false,
				error: action.payload, // store error text
				MRRowData: null, // clear any previous MR data
				MRDetailsModel: true, // keep modal open
			};
		case MR_SR_CODE_DETAILS_SUCCESS:
			var poitems = state.PORowData.woitems.map((item, i) => {
				if (item.id === state.poItemId) {
					item.mrdata = action.payload;
				}
				return item;
			});
			state = {
				...state,
				PORowData: { ...state.PORowData, poitems: poitems },
				loading: false,
			};
			break;
		case PI_SR_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				poItemId: action.payload.ItemId,
			};
			break;
		case PI_SR_CODE_DETAILS_SUCCESS:
			var poitems_1 = state.PORowData.woitems.map((item, i) => {
				if (item.id === state.poItemId) {
					item.pidata = action.payload;
				}
				return item;
			});
			state = {
				...state,
				PORowData: { ...state.PORowData, poitems: poitems_1 },
				loading: false,
			};
			break;

		case HANDLE_SR_BASE_PRICE:
			state = {
				...state,
				PORowData: {
					...state.PORowData,
					// poitems: state.PORowData.woitems.map((item) =>{

					// })
				},
			};
			break;
		case ORDER_BASEPRICE_SR_CHANGEVALUE:
			var qitems8 = state.PORowData.woitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.baseprice = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
					// i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7 || [],
				PORowData: {
					...state.PORowData,
					poitems: qitems8,
				},
			};
			break;
		case ORDER_TAX_SR_CHANGEVALUE:
			var qitems5 = state.PORowData.woitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.tax = {
						id: action.payload.id,
						tax: action.payload.tax,
						name: action.payload.name,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7 || [],
				PORowData: {
					...state.PORowData,
					poitems: qitems5,
				},
			};
			break;
		case ORDER_TAXTYPE_SR_CHANGEVALUE:
			var qitems4 = state.PORowData.woitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.taxtype = action.payload.value;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7 || [],
				PORowData: {
					...state.PORowData,
					poitems: qitems4,
				},
			};
			break;
		case ITEM_GROSS_VAL_SR_CHANGEVALUE:
			var qitems6 = state.PORowData.woitems.map((i) => {
				console.log("I", i);
				if (i.id === action.payload.item.id) {
					i.gross = parseFloat(action.payload.net);
					i.taxamount = parseFloat(action.payload.taxamount);
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems6 || [],
			};
			break;

		case ORDER_DISC_PERCENT_SR_CHANGEVALUE:
			var qitems7 = state.PORowData.woitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.discountpercent = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7 || [],
				PORowData: {
					...state.PORowData,
					poitems: qitems7,
				},
			};
			break;
		case SR_PO_ITEM_ACKNOWLEDGE_OPEN:
			state = {
				...state,
				loading: false,
				POIacknowledgeData: {
					poitem_id: action.payload.POItem_Id,
					purchaseorder_id: action.payload.PO_ID,
				},
				POIacknowledge_Model: true,
			};
			break;
		case SR_PO_ITEM_ACKNOWLEDGE_CLOSE:
			state = {
				...state,
				loading: false,
				POIacknowledge_Model: false,
				POIacknowledgeData: {},
			};
			break;

		case PO_CLOSE_SR_MODAL_OPEN:
			state = {
				...state,
				POClose_Model: true,
			};
			break;
		case PO_CLOSE_SR_MODAL_CLOSE:
			state = {
				...state,
				POClose_Model: false,
			};
			break;
		case SR_PO_ITEM_INPUT_SR_CHANGEVALUE:
			state = {
				...state,
				POIacknowledgeData: {
					...state.POIacknowledgeData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;

		case PO_CLOSE_SR_DESCRIPTION:
			state = {
				...state,
				POClose_Model_Description: {
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case SR_PO_ITEM_ACKNOWLEDGE:
			state = {
				...state,
				loading: true,
			};
			break;

		case SUBMIT_SR_EDIT_ORDER:
			state = {
				...state,
				loading: true,
			};
			break;
		case SUBMIT_SR_EDIT_ORDER_SUCCESSFULL:
			state = {
				...state,
				loading: false,
			};
			break;
		case SR_LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case FILTERS_SHOW_SRQ_RIGHT_SIDEBAR:
			state = {
				...state,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE:
			state = {
				...state,
				showViewLogRightSidebar: !state.showViewLogRightSidebar,
			};
			break;
		case PO_SR_HISTORY_SUCCESS:
			state = {
				...state,
				POItemHistory: action.payload,
			};
			break;

		case VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE:
			state = {
				...state,
				itemTimeLine: [],
				mrIssueItem: [],
				PIitemTimeLine: [],
				RFQItemsTimeLine: [],
				POItemsTimeLine: [],
				IGPItemsTimeLine: [],
				IGPTimeLine: [],
				selectedPIItemId: 0,
				selectedCQItemId: 0,
				selectedIGPItemId: 0,
				showViewLogRightSidebar: false,
			};
			break;
		case FILTERS_HIDE_SR_RIGHT_SIDEBAR:
			state = {
				...state,

				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case SR_PDF_DOWNNLOAD:
			state = {
				...state,
				loading: false,
			};
			break;
		case SR_PURCHASE_ORDER_CLOSE:
			state = {
				...state,
				loading: false,
			};
			break;
		case SR_PURCHASE_ORDER_FOUCS_POST:
			state = {
				...state,
				loading: false,
			};
			break;
		default:
			state = { ...state };
			break;
	}

	return state;
};
export default SRPurchaseOrder;
